import { render } from "./IconBooleanOption.vue?vue&type=template&id=48b807ec"
import script from "./IconBooleanOption.vue?vue&type=script&lang=js"
export * from "./IconBooleanOption.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nekenaratafitaharitsimba/Work/HULSIA/PROJECTS/smilemood-v2/smilemood-v2-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconBooleanOption.vue"]])

export default __exports__